import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-transform duration-300 hover:-translate-y-1">
      <Link to={`/series/${comic.id}`} className="relative block overflow-hidden">
        <div className="aspect-[3/4] w-full overflow-hidden">
          <img
            src={comic.image}
            alt={`${comic.title} 漫画封面`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-2.5 top-2.5 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
          {comic.genre}
        </span>
        <span className="absolute right-2.5 top-2.5 rounded-md bg-background-950/70 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {comic.updated}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-3.5">
        <Link to={`/series/${comic.id}`}>
          <h3 className="text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
            {comic.title}
          </h3>
        </Link>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
          {comic.description}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs">
          <span className="text-foreground-500">已更 {comic.chapters} 话</span>
          <span className="flex items-center gap-1 font-medium text-accent-600">
            <i className="ri-star-fill"></i>
            {comic.rating}
          </span>
        </div>
      </div>
    </article>
  );
}